import LoadingSpinner from '../components/Loading/LoadingSpinner';

function SuspenseContent(){
    return(
        <div className="w-full h-screen flex items-center justify-center text-gray-300 dark:text-gray-200 bg-base-100">
            <LoadingSpinner message="애플리케이션을 불러오는 중..." size="lg" className="border-0" />
        </div>
    )
}

export default SuspenseContent